import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = { class: "accordion-header" }
const _hoisted_3 = { class: "accordion-body" }


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileAccordionItem',
  props: {
    title: {},
    isOpen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["accordion-button", { collapsed: !__props.isOpen }]),
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
      }, _toDisplayString(__props.title), 3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["accordion-collapse collapse", { show: __props.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ]))
}
}

})